import { render, staticRenderFns } from "./WithBackdrop.vue?vue&type=template&id=26aea0d1"
import script from "./WithBackdrop.vue?vue&type=script&lang=js"
export * from "./WithBackdrop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports